import { ICabinetWithDimensions } from "../models/IcabinetWithDimensions";
import { ICabinet } from "./WebApiClient";


export function hasProductLine(cabinet: ICabinet): cabinet is (ICabinet & { productLineId: number }) {
    return notNullish(cabinet.productLineId);
}

export function hasDimensions(cabinet: ICabinet): cabinet is ICabinetWithDimensions {
    return notNullish(cabinet.width)
        && notNullish(cabinet.height)
        && notNullish(cabinet.depth);
}
export function hasDoorProduct(cabinet: ICabinet): cabinet is (ICabinet & { doorProductId: number }) {
    return notNullish(cabinet.doorProductId);
}

function notNullish<T> (t: T|null|undefined): t is T{
    return t !== null && t !== undefined;
}
function nullish<T>(t: T | null | undefined): t is null | undefined {
    return t === null || t === undefined;
}


export function assertHasDimensions(cabinet: ICabinet): ICabinetWithDimensions {
    if (nullish(cabinet.width)
        || nullish(cabinet.height)
        || nullish(cabinet.depth))
        throw new Error("assertion failed");
    return cabinet as any as ICabinetWithDimensions;
}
